import Component from '@glimmer/component';
import { PrismButton } from '@mylighthouse/prism-ember';
import type { RecommendationStrategy } from 'lumen/models';

import styles from './seasonal-strategy-card.module.css';

interface SettingsPmsIntegrationSeasonalStrategyCardSignature {
  Args: {
    isReadOnly: boolean;
    onDelete: () => void;
    strategy: RecommendationStrategy;
  };
  Element: HTMLDivElement;
}

export default class SettingsPmsIntegrationSeasonalStrategyCard extends Component<SettingsPmsIntegrationSeasonalStrategyCardSignature> {
  get dateRangeTitle(): string {
    const { seasonEndDt, seasonStartDt } = this.args.strategy;

    if (!seasonStartDt || !seasonEndDt) {
      return '';
    }

    if (seasonStartDt.isSame(seasonEndDt, 'day')) {
      return seasonStartDt.format('DD MMM YYYY');
    }

    return `${seasonStartDt.format('DD MMM YYYY')} - ${seasonEndDt.format(
      'DD MMM YYYY',
    )}`;
  }

  <template>
    <div class={{styles.card}} data-test-id="seasonal-strategy-card">
      <div class="flex flex-col">
        <p class="text-200--regular" data-test-id="season-date-range">
          {{this.dateRangeTitle}}
        </p>
        <h3 data-test-id="season-name">{{@strategy.name}}</h3>
      </div>

      {{#unless @isReadOnly}}
        <PrismButton
          @buttonType="ghost"
          @icon="bin"
          @onClick={{@onDelete}}
          data-test-id="delete-seasonal-strategy-button"
        />
      {{/unless}}
    </div>
  </template>
}
